import { useStaticQuery, graphql } from "gatsby"

export const useTeamleden = () => {
  const data = useStaticQuery(graphql`
    query TeamledenQuery {
      allWpTeamlid {
        edges {
          node {
            title
            teamleden {
              functietitel
              linkedinLink
              tekst
            }
            featuredImage {
              node {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  return data
}
